import app from 'flarum/forum/app';
import ItemList from 'flarum/common/utils/ItemList';
import Switch from 'flarum/common/components/Switch';
export default function RealtimeUserPreferencesItems(user) {
  var _preferences;
  const items = new ItemList();
  let typingIndicatorLoading = false;
  items.add('typing-indicator', [m(Switch, {
    state: (_preferences = user.preferences()) == null ? void 0 : _preferences['flarum-realtime.typing-indicator-full'],
    onchange: value => {
      typingIndicatorLoading = true;
      user.savePreferences({
        'flarum-realtime.typing-indicator-full': value
      }).then(() => {
        typingIndicatorLoading = false;
        m.redraw();
      });
    },
    loading: typingIndicatorLoading
  }, app.translator.trans('flarum-realtime.forum.user.settings.typing-indicator-type.label')), m("p", {
    className: "helpText"
  }, app.translator.trans('flarum-realtime.forum.user.settings.typing-indicator-type.help'))], 80);
  return items;
}
flarum.reg.add('flarum-realtime', 'forum/extend/User/RealtimeUserPreferences', RealtimeUserPreferencesItems);